<template>
  
  <v-flex xs12 sm12 md12>

    <v-parallax height=200 :src="parallaxImg">
      <v-layout align-center column justify-center>
        <h1 class="display-3 font-weight-thin mb-3">Turing Form</h1>
        <h4 class="subheading text-xs-center">Simple and free form/survey for anything.</h4>
        <span><router-link to="/" class="white--text">TuringForm</router-link></span>
      </v-layout>
    </v-parallax>

    <v-form v-model="valid" ref="form">
      <v-container>

        <v-flex xs12 md6>

          <v-layout row wrap>

            <v-flex xs12 md12>
              <h1 class="text-xs-center mb-0">Signup</h1>

              <v-alert :value="errored" color="error">
                {{errorMsg}}
              </v-alert>
            </v-flex>

            <v-flex xs12 md12>
              <v-text-field
                v-model="name"
                :rules="[rules.required]"
                label="Name"
                required
                autofocus
                full-width
                outline
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md12>
              <v-text-field
                v-model="email"
                :rules="[rules.required]"
                label="E-mail"
                required
                full-width
                outline
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md12>
              <v-text-field
                v-model="password"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                :rules="[rules.required, rules.min]"
                :type="showPassword ? 'text' : 'password'"
                label="Password"
                @click:append="showPassword = !showPassword"
                full-width
                outline
              ></v-text-field>
            </v-flex>

            <v-flex xs12 md12>
              <v-btn block large color="primary" @click="signup">Signup</v-btn>
            </v-flex>

            <v-flex xs12 md12 mt-5 mb-5>
              <h1 class="headline text-xs-center">Already have an account?</h1>

              <router-link to="/login">
                <v-btn block large outline color="primary">Login</v-btn>
              </router-link>
            </v-flex>

          </v-layout>

        </v-flex>

      </v-container>
    </v-form>

    

  </v-flex>

</template>

<script>
// @ is an alias to /src

export default {
  name: "login",
  components: {},
  props: {},
  data: () => ({
    parallaxImg : require('@/assets/parallax.jpeg'),
    valid: false,
    name: '',
    email: '',
    password: '',
    showPassword: false,
    errored: false,
    errorMsg : "",
    rules: {
      required: value => !!value || 'Cannot Be Empty.',
      min: v => v.length >= 8 || 'Min 8 characters',
      emailMatch: () => ('The email and password you entered don\'t match')
    }
  }),
  computed: {},
  watch: {},
  created(){},
  mounted(){
  },
  methods: {
    signup() {

      if (!this.$refs.form.validate()){
        return;
      }

      firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
      .then((ret)=>{
        var user = firebase.auth().currentUser;
        
        user.updateProfile({
          displayName: this.name
        });

        user.sendEmailVerification().then(()=> {
          // Email sent.
          this.$router.push('/');
        }).catch(function(error) {
          // An error happened.
        });

      })
      .catch((error) => {
        if (error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          this.errorMsg = error.message;
          this.errored = true;
          // window.bugsnagClient.notify(new Error(error));
          return;
        }
      });

    }
  }
};
</script>

<style scoped>

</style>